export default __webpack_public_path__ + "static/media/katarzyna-greczka-boldare.0c3c7b54.png";